export const WhiteListedRoutes = Object.freeze({
  LOGIN: '/login',
  LOGIN_TRAILING: '/login/',
  LOGIN_FORGOT_PASS: '/login/forgot-pass',
  LOGIN_FORGOT_PASS_TRAILING: '/login/forgot-pass/',
  RESET: '/reset',
  RESET_TRAILING: '/reset/',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_TRAILING: '/reset-password/',
  REGISTRATION: `//${process.env.www}/registration`,
  ACTIVATE_ACCOUNT: '/activate-account',
  ACTIVATE_ACCOUNT_TRAILING: '/activate-account/',
  C: '/c/',
  ACTIVATION: '/activation',
  ACTIVATION_TRAILING: '/activation/',
  ACTIVATION_EXPIRED: '/activation-expired',
  ACTIVATION_EXPIRED_TRAILING: '/activation-expired/',
  PAYMENT: '/payment',
  SETTINGS: '/settings',
  // $1 Premium People trial lead landing (BIO-1350). Public / lead-facing: a no-account visitor
  // (or a campaign recipient before auth resolves) must reach it without a login bounce, and it
  // also exempts the path from handleOnboardingRouting, which keys its skip-list off this list.
  TRIAL_PREMIUM_PEOPLE: '/trial/premium-people',
});

export const APIRoutes = Object.freeze({
  REFRESH_TOKEN: '/auth/v3/refresh',
  CONSUME_TOKEN: '/auth/v3/token/consume',
});

export const AppRoutes = Object.freeze({
  DASHBOARD: '/dashboard',
  OPERATING_FEED: '/operating-feed',
  TASK_CENTER: '/task-center',
});

const Routes = { ...WhiteListedRoutes };
export default Routes;
